import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AllProviders, GameWithProviders } from "~/app";
import { XGame } from "./XGame";
import { XListGamesPage } from "./components/lobby/XListGamesPage";
import { XStorybook } from "./components/storybook/XStorybook";
import { SelectionProvider } from "./context/SelectionContext";
import { routeBuilder } from "./routeBuilder";

const XNotFound = () => {
  return <div>not found</div>;
};

export const XRouter = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to={routeBuilder.listGames} />} />
        <Route path={routeBuilder.listGames} element={<XListGamesPage />} />
        <Route
          path={routeBuilder.storybook}
          element={
            <AllProviders>
              <SelectionProvider>
                <XStorybook />
              </SelectionProvider>
            </AllProviders>
          }
        />
        <Route
          path="/game/:gameId/:gameData"
          element={
            <SelectionProvider>
              <GameWithProviders>
                <XGame />
              </GameWithProviders>
            </SelectionProvider>
          }
        />
        <Route path="*" element={<XNotFound />} />
      </Routes>
    </BrowserRouter>
  );
};
